import { render, staticRenderFns } from "./quickBuy.vue?vue&type=template&id=132b1148&scoped=true"
import script from "./quickBuy.vue?vue&type=script&lang=js"
export * from "./quickBuy.vue?vue&type=script&lang=js"
import style0 from "./quickBuy.vue?vue&type=style&index=0&id=132b1148&prod&lang=scss"
import style1 from "./quickBuy.vue?vue&type=style&index=1&id=132b1148&prod&scoped=true&lang=css"
import style2 from "./quickBuy.vue?vue&type=style&index=2&id=132b1148&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132b1148",
  null
  
)

export default component.exports